/*! tooltips.js
    v0.1 (c) Mircea Piturca
    MIT License
*/
function initializeHotspots() {
  (function ThemeEditor(SD) {
    var sectionElement = document.querySelector('.tooltips-section');
    var sectionId = sectionElement.getAttribute('data-tooltips');

    if (SD.ThemeEditor[sectionId]) return;

    SD.ThemeEditor[sectionId] = 'init';
    initEvents(sectionId);

    document.addEventListener('shopify:section:load', function (evt) {
      if (evt.detail.sectionId !== sectionId) return;

      var section = SD[sectionId];
      section.init(section.config);
      initEvents(sectionId);
    });

    function initEvents(sectionId) {
      var sectionHost = document.querySelector('.tooltips-section[data-tooltips="' + sectionId + '"]');

      sectionHost.addEventListener('shopify:block:select', toggleSelect);
      sectionHost.addEventListener('shopify:block:deselect', toggleSelect);
    }

    document.addEventListener('shopify:block:select', toggleSelect);

    function toggleSelect(evt) {
      var sectionId = evt.detail.sectionId;
      var blockId = evt.detail.blockId;
      var section = SD[sectionId];

      evt.type === 'shopify:block:select'
        ? section.select(blockId)
        : section.deselect(blockId);

      updateBlocks(section, blockId);
    }

    function updateBlocks(section, blockId) {
      if (section.config.blocksId.indexOf(blockId) === -1) {
        section.config.blocksId.push(blockId);
      }
    }
  })(window.SectionsDesign = window.SectionsDesign || { ThemeEditor: [] });

  (function Tooltips(SD) {
    'use strict';

    var support = getSupport();
    var instances = nodeList('[data-tooltips-config]');

    instances.map(function(instance) {
      var config = Object.freeze(getConfig(instance));

      var publicAPI = {
        tooltips: function() { return getTooltips(config) },
        tooltip: getTooltip,
        select: select,
        deselect: deselect,
        config: config,
        init: init
      }

      if (!SD[config.sectionId]) init(config);    
      SD[config.sectionId] = publicAPI;
      
      return publicAPI;
    });

    function init(config) {
      var tooltips = getTooltips(config);
      var triggers = pluck(tooltips, 'trigger');

      triggers.map(function (element) {
        element.addEventListener('click', function triggerClick() {
          tooltipClick(tooltips, element.value);
        });

        document.addEventListener('click', function documentClick(event) {
          var target = event.target;
          var isTooltipClick = false;

          while (target) {
            if (target.classList.contains('tooltip-item')) {
              isTooltipClick = true;
              break;
            }
            target = target.parentElement;
          }

          if (!isTooltipClick) {
            tooltips.filter(not(isCollapsed)).map(collapse);
          }
        });
      });
    }

    function getConfig(instance) {
      return JSON.parse(instance.innerHTML);
    }

    function getTooltips(config) {
      return config.blocksId.map(getTooltip);
    }

    function getTooltip(id) {
      var host = document.getElementById('tooltip-' + id);

      return {
        id: id,
        trigger: host.querySelector('[data-tooltip-trigger]'),
        overlay: host.querySelector('[data-tooltip-overlay]'),
        markup: host.querySelector('[data-tooltip-markup]'),
        get collapsed() { return isCollapsed(this) }
      }
    }

    function tooltipClick(tooltips, id) {
      var isSelected = partial(idMatch, id);
      tooltips.filter(isSelected).map(toggle);
      tooltips.filter(not(isSelected)).filter(not(isCollapsed)).map(collapse);
    }

    function toggle(tooltip) {
      tooltip.collapsed ? expand(tooltip) : collapse(tooltip);
    }

    function expand(tooltip) {
      var markupContent = tooltip.markup.innerHTML;
      tooltip.overlay.innerHTML = markupContent;
      tooltip.overlay.style.setProperty('--end-h', height(tooltip));
      tooltip.overlay.style.setProperty('--start-h', '0px');
      tooltip.trigger.setAttribute('aria-expanded', true);

      tooltip.overlay.addEventListener('animationend', function animationEndFn() {
        animationReset(tooltip.overlay, animationEndFn);
      });
      return tooltip;
    }

    function collapse(tooltip) {
      tooltip.overlay.style.setProperty('--start-h',  height(tooltip));
      tooltip.overlay.style.setProperty('--end-h', '0px');
      tooltip.trigger.setAttribute('aria-expanded', false);

      if (!support.customProperties) tooltip.overlay.innerHTML = '';

      tooltip.overlay.addEventListener('animationend', function animationEndFn() {
        animationReset(tooltip.overlay, animationEndFn);
        tooltip.overlay.innerHTML = '';
      });

      return tooltip;
    }

    function animationReset(element, callback) {
      element.removeAttribute('style');
      element.removeEventListener('animationend', callback);
    }

    function idMatch(id, tooltip) {
      return tooltip.id === id;
    }

    function isCollapsed(tooltip) {
      return attr('aria-expanded', tooltip.trigger) === 'false';
    }

    function height(tooltip) {
      return px(tooltip.overlay.offsetHeight.toString());
    }

    function px(n) {
      return n + 'px';
    }

    function attr(str, element) {
      return element.getAttribute(str);
    }

    function nodeList(str, root) {
      if (!root) root = document;
      var nodeList = root.querySelectorAll(str);
      return Array.prototype.slice.call(nodeList);
    }

    function not(predicate) {
      return function negated() {
        return !predicate.apply(undefined, arguments);
      };
    }

    function pluck(array, key) {
      return array.map(function(obj) {
        return obj[key];
      });
    }

    function partial(fn) {
      var slice = Array.prototype.slice;
      var args = slice.call(arguments, 1);
      return function() {
        return fn.apply(this, args.concat(slice.call(arguments, 0)));
      };
    }

    function getSupport() {
      return {
        customProperties: window.CSS && CSS.supports('color', 'var(--primary)'),
      }
    }

    function select(blockId) {
      return expand(getTooltip(blockId));
    }

    function deselect(blockId) {
      return collapse(getTooltip(blockId));
    }
  })(window.SectionsDesign = window.SectionsDesign || {});
}
